import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "row align-items-end" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-4 d-flex align-items-end"
}
const _hoisted_6 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { style: {"width":"200px"} }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_19 = {
  class: "dropdown-menu dropdown-block",
  style: {"position":"absolute","inset":"0px auto auto 0px","margin":"0px","transform":"translate(267px, 305px)"},
  "data-popper-placement": "bottom-start"
}
const _hoisted_20 = {
  key: 0,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Liste des fiches controlées")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.checkPermission('AddControlFiche'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  class: "btn btn-primary",
                  to: "/controls/ajouter-control"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                    _createTextVNode(" Ajouter un control ")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.point_ventes.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Filtrer par Point de vente ", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.point_vente,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.point_vente) = $event)),
                      options: _ctx.point_ventes,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      placeholder: "Sélectionner un point de vente"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("form", {
                class: "search-bg svg-color pt-3 w-100",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
                    onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
                    class: "form-control shadow-none text-black flex-grow-1",
                    placeholder: "Rechercher un control"
                  }, null, 544), [
                    [_vModelText, _ctx.searchTerm]
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("button", {
                    type: "submit",
                    class: "bg-transparent text-primary transition p-0 border-0 ms-2"
                  }, [
                    _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                  ], -1))
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("table", _hoisted_14, [
          _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date contrôl "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Fiche Produit "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Observation "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              }, "ACTIONS")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controls, (control, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.format_date( control.dateControl)), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(control.ficheProduit.numFiche) + " " + _toDisplayString(control.ficheProduit.produit.nomProd), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(control.ObservationGlobal), 1),
                _createElementVNode("td", _hoisted_18, [
                  _cache[8] || (_cache[8] = _createElementVNode("button", {
                    class: "btn dropdown-toggle btn-primary",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, "Actions", -1)),
                  _createElementVNode("ul", _hoisted_19, [
                    (_ctx.checkPermission('DeleteControlFiche'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.suppression(control.id,_ctx.controls,'controls',`l\'control ${control.id}`))
                          }, _cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Supprimer ")
                          ]), 8, _hoisted_21)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}